import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Subscription } from "../types/subscription";

export const getSubscription = async (config: {
  "sub-id": string;
}): Promise<Subscription> => {
  const ednString = toEDNStringFromSimpleObject(config as any, { keysAs: "string" });
  const query = `
(datastore Qo.Public.Api.Sub "omega/query-omega/public/api/subscription")
(Qo.Public.Api.Sub/subscription-object ${ednString} Sub)
(return [Sub])
  `;
  return queryOmegaSingleResult(query);
};
